import { Box, Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { SmallLoadingSpinner } from '../../../components/LoadingSpinner';
import type { WidgetSource } from '../constants';
import { METRIC_WIDGET_CONTENT_HEIGHT } from '../constants';

export type IMetricLoadingOrEmptyProps = {
	source: WidgetSource;
	isEmpty?: boolean;
	isLoading?: boolean;
	/**
	 * When true, the metric query ran successfully but produced no rows
	 * (e.g. no editor activity in the lookback window). This is distinct from
	 * `isEmpty`, which is shown when the metric has never been generated yet.
	 */
	hasNoEvents?: boolean;
};

export function MetricLoadingOrEmpty({
	source,
	isEmpty,
	isLoading,
	hasNoEvents,
}: IMetricLoadingOrEmptyProps) {
	const height = METRIC_WIDGET_CONTENT_HEIGHT[source];

	if (isLoading) {
		return (
			<Box h={height}>
				<SmallLoadingSpinner />
			</Box>
		);
	}

	if (hasNoEvents) {
		return (
			<Group position="center" align="center" h={height} w="100%">
				<Text
					color="text/secondary/default"
					size={source === 'preview' ? 'xs' : 'sm'}
					align="center"
				>
					No events were recorded for this period.
				</Text>
			</Group>
		);
	}

	if (isEmpty) {
		return (
			<Group position="center" align="center" h={height} w="100%">
				<Text
					color="text/secondary/default"
					size={source === 'preview' ? 'xs' : 'sm'}
				>
					No data available
				</Text>
			</Group>
		);
	}

	return null;
}
